// extracted by mini-css-extract-plugin
export default {"tableRow":"tableRow__Mmw6G","modal":"modal__82uWU"};